module.exports = __webpack_public_path__ + "static/bg-band-mobile-cbbcc76d5f8898b63c080875983be3b2.jpg";